export default "__VITE_ASSET__BKV7ZyWy__"